import React from "react";
import LoadButtons from "../LoadButtons"
import styles from "./MainApp.organisms.Product.LoadButtonsContainer.module.scss";
import i18n from "i18n";

export class LoadButtonsContainer extends React.Component {
  render() {
    return (
      <div className={styles["load-products-buttons-wrapper"]}>
        <div className={styles["load-products-button"]}>
          <LoadButtons
            title={i18n.t("single.load.title")}
            subtitle={i18n.t("single.load.subtitle")}
            icon="icon-iconos_producto"
            handleFunc={this.props.handleSingleProductClick}

          />
        </div>
        <div className={styles["load-products-button"]}>
          <LoadButtons
            title={i18n.t("massive.load.title").toUpperCase()}
            subtitle={i18n.t("massive.load.subtitle")}
            icon="icon-iconos_varios_productos"
            handleFunc={this.props.handleMassiveProductClick}
          />
        </div>
      </div>
    );
  }
}

LoadButtonsContainer.propTypes = {};

export default LoadButtonsContainer;
